<div class="main-container centered" @fadeIn>
	<p><strong>Thank you for using Vitralogy Binder</strong></p>
	<p class="secondary">This QR access code has been disabled.<br>Please contact your administrator.</p>
</div>
